// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center-content-position[data-v-fb0641ac] {\n  width: 80% !important;\n}\n.form-actions[data-v-fb0641ac] {\n  text-align: center;\n}\n.has-error .form-control[data-v-fb0641ac] {\n  box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
